





















/* General */
import Vue from 'vue'

/* Mixins */

/* Components */
import mailboxesImg from '@/assets/img/entities/illustration-mailbox-empty-state.png'
import mailboxesImg2x from '@/assets/img/entities/illustration-mailbox-empty-state@2x.png'
import mailboxesImg3x from '@/assets/img/entities/illustration-mailbox-empty-state@3x.png'
import projectsImg from '@/assets/img/entities/illustration-project-empty-state.png'
import projectsImg2x from '@/assets/img/entities/illustration-project-empty-state@2x.png'
import projectsImg3x from '@/assets/img/entities/illustration-project-empty-state@3x.png'

/* Helpers */

/* Data types */
import { EEntities } from '@/types'

/* API */

export default Vue.extend({
  name: 'EmptyListState',

  props: {
    type: {
      type: String as () => EEntities,
      required: true,
    },

    isMultiEntity: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      displayInfos: {
        mailboxes: {
          title: 'No conversations here!',
          description: `Please try a different filter.`,
          img: mailboxesImg,
          img2x: mailboxesImg2x,
          img3x: mailboxesImg3x,
        },
        projects: {
          title: 'No tasks here!',
          description: `Please try a different filter.`,
          img: projectsImg,
          img2x: projectsImg2x,
          img3x: projectsImg3x,
        },
      },
    }
  },

  computed: {
    displayInfo(): any {
      return this.displayInfos[this.type]
    },
    isMailbox(): boolean {
      return this.type === EEntities.MAILBOXES
    },
    isProject(): boolean {
      return this.type === EEntities.PROJECTS
    },
  },
})
